import React, { useState, useEffect } from 'react';
import ArticleBlock from '../../adapters/helpers/ArticleBlock';
import { mediaQueryHOC } from '../../adapters/helpers/Hooks';

import { ArticleConstants } from '../../adapters/helpers/Constants';
import GetHelpLayout from './GetHelpLayout';
import ArticleMobileLayout from './ArticleMobileLayout';
import ArticleDesktopLayout from './ArticleDesktopLayout';

interface ExtraAttributes {
    entity?: {
    className?: string;
    isNewArticleRevampPage?: boolean;
    fields?: object;
    tableOfContent?: object;
    aboutTheAuthor?: object;
    introContent?: string;
    keyTakeaways?: object;
    references?: object;
    getHelpButton?: object;
    getHelpLink?: object;
    contactUs?: object;
    rightArrowIconArticle?: { fields: { file: { url: string } } };
    leftArrowIconArticle?: { fields: { file: { url: string } } };
    faQs?: object;
    articleIntro?: {
      fields?: {
        intro?: string;
        className?: string;
        };
    };
    relatedProducts?: object[];
    relatedArticles?: object[];
    name?: string;
  };
  extraAttributes?: { [key: string]: any };
}

interface DocumentFields {
    blog?: object;
  signupBlock?: object;
  [key: string]: any;
}

interface ArticleBodyProps {
    className?: string;
  extraAttributes?: ExtraAttributes;
  document: {
    sys: {
      updatedAt?: string;
    };
    fields?: DocumentFields;
  };
  onClickCallback?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  customEvent?: object;
  isLarge?: boolean;
  isXSmall?: boolean;
  isSmall?: boolean;
}

const ArticleBody: React.FC<ArticleBodyProps> = (props) => {
    const { isXSmall, isSmall, extraAttributes, document } = props;
  const {
    blog: blogContent,
    signupBlock: signupContent,
    rightArrowIcon: rightArrowIconLink,
    leftArrowIcon: leftArrowIconLink,
  } = document?.fields || {};
  const getHelpPage =
    extraAttributes?.entity?.name === ArticleConstants.GetHelpPage;

    const article = extraAttributes?.entity;
  const {
    className: classAttribute,
    tableOfContent,
    aboutTheAuthor: authorContent,
    keyTakeaways: keyTakeawaysContent,
    articleIntro: introContent,
    faQs: faqContent,
    relatedProducts,
    relatedArticles,
    references: references,
    getHelpButton: buttonContent,
    getHelpLink: linkContent,
    contactUs: contactUsContent,
  } = article || {};

    const isMobile = isXSmall || isSmall;

    const articleBlock = new ArticleBlock({ document: document, article });
    const intro = introContent?.fields?.intro;
    const introClassname = introContent?.fields?.className;
    const lastUpdatedDate = document?.sys?.updatedAt;
    const [isArticle, setIsArticle] = useState(true);
    const [activeIndex, setActiveIndex] = useState(0);
    const [topicIndex, setTopicIndex] = useState(-1);

    const children =
    !isMobile &&
    articleBlock.renderChildBlocks(
      { extraAttributes },
      props.onClickCallback,
      props.customEvent
    );
    const childrenMobile =
    isMobile &&
    articleBlock.renderMobileChildrensBlocks(
      { extraAttributes },
      props.onClickCallback,
      props.customEvent
    );

  return (
    <div className={`article-revamp-body w-full ${classAttribute}`}>
      {getHelpPage ? (
        <GetHelpLayout
          isMobile={!!isMobile}
          intro={intro}
          introClassname={introClassname}
          tableOfContent={tableOfContent}
          buttonContent={buttonContent}
          linkContent={linkContent}
          contactUsContent={contactUsContent}
          children={children}
          childrenMobile={childrenMobile}
        />
      ) : isMobile ? (
        <ArticleMobileLayout
          intro={intro}
          introClassname={introClassname}
          lastUpdatedDate={lastUpdatedDate}
          tableOfContent={tableOfContent}
          blogContent={blogContent}
          keyTakeawaysContent={keyTakeawaysContent}
          childrenMobile={childrenMobile}
          faqContent={faqContent}
          activeIndex={activeIndex}
          topicIndex={topicIndex}
          relatedProducts={relatedProducts}
          isMobile={!!isMobile}
          onClickCallback={props.onClickCallback}
          isArticle={isArticle}
          rightArrowIconArticle={rightArrowIconLink}
          leftArrowIconArticle={leftArrowIconLink}
          references={references}
          authorContent={authorContent}
          relatedArticles={relatedArticles}
          signupContent={signupContent}
        />
      ) : (
        <ArticleDesktopLayout
          intro={intro}
          lastUpdatedDate={lastUpdatedDate}
          keyTakeawaysContent={keyTakeawaysContent}
          isMobile={!!isMobile}
          children={children}
          faqContent={faqContent}
          activeIndex={activeIndex}
          topicIndex={topicIndex}
          references={references}
          authorContent={authorContent}
          tableOfContent={tableOfContent}
          blogContent={blogContent}
          relatedProducts={relatedProducts}
          onClickCallback={props.onClickCallback}
          isArticle={isArticle}
          rightArrowIconArticle={rightArrowIconLink}
          leftArrowIconArticle={leftArrowIconLink}
          signupContent={signupContent}
          relatedArticles={relatedArticles}
        />
      )}
    </div>
  );
};

export default mediaQueryHOC(ArticleBody);